import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MyProfileService } from "../myprofile.service";
import { MyProfile } from "../myprofile.model";
import { Router } from "@angular/router";
import { AppRoute } from "../../../shared/app.routes";
import { NotificationService, ValidationService } from "../../../shared/services/service.index"
;
import { AddressModel } from "../../company/company.model";
import { ActivatedRoute } from "@angular/router";
import { AppConfig } from "../../../app.config";
import { CurrentLoggedInUserService } from "../../../shared/services/currentloggedinuser.service";
import { confirmPasswordValidator, confirmCodeValidator } from "../../../shared/services/validation.service";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CropImageComponent } from "../crop-image/crop-image.component";
import { DropdownModel } from "../../../shared/models/dropdown.model";
import { AuthenticationService } from "../../authentication/authentication.service";
import { Role } from "../../../shared/models/useridentity.model";
import { FuseAlertService } from '@fuse/components/alert';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.scss'
})

export class EditProfileComponent implements OnInit, OnDestroy {
  isClientAdmin: boolean = false;
  companyCodeLabel: CompanyCodeLabelModel;
  email: string;
  code: string;
  frmChangePassword: FormGroup;
  isSubmitChangePasswordBtnDisabled: boolean = false;
  tabTitleLable: string;
  frmSetOrChangeCompanyCode: FormGroup;
  isSubmitChangeSecurityCodeBtnDisabled: boolean = false;
  isSetCompanyCode: boolean = true;
  isSubmitEditProfileBtnDisabled: boolean = false;
  editProfileForm: FormGroup;
  isEditMode: boolean = false;
  myProfile: MyProfile = null;
  apiResponseErrorMessage: string = null;
  apiResponseErrorMessageChangePassword: string = null;
  apiResponseErrorMessageChangeSecurityCode: string = null;
  notificationService: NotificationService;
  selectedIndex: number;
  userRoleName: string;

  selectedCountryDropdown: DropdownModel;

  public mask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  /**Country and State value to bind in edit mode**/
  selectedCountryName: string;
  selectedStateName: string;

  /**Mat Dialog variables**/
  confirmDialogRef: MatDialogRef<CropImageComponent>;
  dialogRef: any;
  currentUser: any;
  
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _myProfileService: MyProfileService,
    private snb: MatSnackBar,
    private readonly matDialog: MatDialog,
    private readonly currentRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private readonly authenticationService: AuthenticationService,
    private readonly appConfig: AppConfig,
    public fuseAlertService: FuseAlertService,
    private _currentLoggedInUserService: CurrentLoggedInUserService

  ) {
    this.currentUser = this.appConfig.getCurrentUser(true);
    this.isClientAdmin = this.currentUser.role == Role.ClientAdmin;
    this.notificationService = new NotificationService(snb);
    this.companyCodeLabel = new CompanyCodeLabelModel();
    this.selectedCountryDropdown = new DropdownModel();
    this.selectedCountryDropdown.value = 0;

    //this.currentRoute.data.subscribe(x => { });

    // Set the private defaults
    this._unsubscribeAll = new Subject();
    if (_currentLoggedInUserService.isChanagePasswordCall) {
      this.selectedIndex = 2;
    }
    this.getUser();

    this.email = this.currentUser.email;
    this.isSetCompanyCode = this.currentUser.isSecurityCodeSet;
    this.tabTitleLable = this.isSetCompanyCode ? "Change Company Code" : "Set Company Code";
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Life cycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.editProfileForm = this._formBuilder.group({
      firstName: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(50), ValidationService.noWhiteSpace]],
      lastName: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(50), ValidationService.noWhiteSpace]],
      extPhoneNumber: ["", [ValidationService.extPhoneNumberValidator]],
      phoneNumber: ["", [Validators.required, ValidationService.phoneNumberValidator]],
      street: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(100), ValidationService.noWhiteSpace]],
      city: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(50), ValidationService.noWhiteSpace]],
      state: ["", Validators.required],
      country: ["", Validators.required],
      zipCode: ["", [Validators.required, Validators.minLength(5), Validators.maxLength(6), ValidationService.noWhiteSpace]],
    });

    this.setChangePasswordForm();
    this.setOrChangeCompanyCodeForm();

    //this.currentRoute.queryParams.subscribe(params => {
    //  this.email = params['email'];
    //  this.code = params['code'];
    //});

    this._currentLoggedInUserService.getCurrentLoggedInUserRole().subscribe(res => {
      if (res.status === 1) {
        const isClientAdmin = res.data[0]; 
        switch (isClientAdmin) {
          case Role.SystemPowerAdmin:
            this.userRoleName = Role.SystemPowerAdminDescription;
            break;
          case Role.SystemUser:
            this.userRoleName = Role.SystemUserDescription;
            break;
          case Role.ClientAdmin:
            this.userRoleName = Role.ClientAdminDescription;
            break;
          case Role.ClientUser:
              this.userRoleName = Role.ClientUserDescription;
              break;
          case Role.SystemAdmin:
              this.userRoleName = Role.SystemAdminDescription;
              break;
          case Role.Resources:
            this.userRoleName = Role.ResourcesDescription;
            break;
          default:
            this.userRoleName = '';
            break;
        }
        console.log('User Role:', this.userRoleName);
      } else {
        console.error('Failed to fetch user roles or invalid status.');
      }
    });    

  }

  /**
  * On destroy
  */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  formatPhoneNumber(event: any) {
    const input = event.target.value.replace(/\D/g, ''); 
    if (input.length > 3 && input.length <= 6) {
      event.target.value = `${input.slice(0, 3)}-${input.slice(3)}`;
    } else if (input.length > 6) {
      event.target.value = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
    } else {
      event.target.value = input;
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Form events
  // -----------------------------------------------------------------------------------------------------
  /**
   * On submit event of Change pasword form
   */
  onSubmitChangePassword() {
    this.apiResponseErrorMessageChangePassword = null;
    let model = {
      currentPassword: this.frmChangePassword.controls.currentPassword.value,
      newPassword: this.frmChangePassword.controls.newPassword.value,
      confirmPassword: this.frmChangePassword.controls.confirmPassword.value,
      userId: ''
    };

    this.spinner.show();
    this.isSubmitChangePasswordBtnDisabled = true;
    if (this.frmChangePassword.dirty && this.frmChangePassword.valid) {

      this._myProfileService.changePassword(model).subscribe(result => {
        this.spinner.hide();
        this.isSubmitChangePasswordBtnDisabled = false;
        if (result.status === 1) {
          //this.notificationService.showNotification(result.message);
          this.fuseAlertService.show(result.message, result.status);
          this.selectedIndex = 0;
          this.resetChangePasswordForm();
        }
        else if (result.status === 2) {
          this.fuseAlertService.show(result.message, result.status);
          //this.apiResponseErrorMessageChangePassword = result.message;
        }
        else if (result.status === 3) {
          this.fuseAlertService.show(result.message, result.status);
          //this.apiResponseErrorMessageChangePassword = result.message;
        }
        else if (result.status === 0) {
          this.fuseAlertService.show(result.message, result.status);
        }
      });
    }

  }

  /**
   * On submit evenet of Edit Profile form
   */
  onSubmit() {

    this.apiResponseErrorMessage = null;
    let editProfileAddressModel = new AddressModel();
    editProfileAddressModel.city = this.editProfileForm.controls.city.value;
    editProfileAddressModel.state = this.editProfileForm.controls.state.value;
    editProfileAddressModel.country = this.editProfileForm.controls.country.value;
    editProfileAddressModel.street = this.editProfileForm.controls.street.value;
    editProfileAddressModel.zipCode = this.editProfileForm.controls.zipCode.value;

    let model = {
      email: this.myProfile.email,
      firstName: this.editProfileForm.controls.firstName.value,
      lastName: this.editProfileForm.controls.lastName.value,
      extPhoneNumber: this.editProfileForm.controls.extPhoneNumber.value,
      phoneNumber: this.editProfileForm.controls.phoneNumber.value,
      profileImagePath: '',
      userId: '',
      address: '',
      editProfileAddressModel: editProfileAddressModel
    };
    this.isSubmitEditProfileBtnDisabled = true;
    if (this.editProfileForm.valid) {
      this.spinner.show();
      this._myProfileService.editProfile(model).subscribe(result => {
        this.spinner.hide();
        this.isSubmitEditProfileBtnDisabled = false;
        if (result.status === 1) {
          //this.notificationService.showNotification(result.message);
          this.fuseAlertService.show(result.message, result.status);
          this.getUser();
          this.selectedIndex = 0;
          this._currentLoggedInUserService.currentUserFullName(model.firstName + " " + model.lastName);
          var currentUserObj = this.appConfig.getCurrentUser();
          if (currentUserObj !== null && currentUserObj !== undefined) {
            currentUserObj.token = this.appConfig.getToken();
            currentUserObj.fullName = model.firstName + " " + model.lastName;
            this.appConfig.setCurrentUser(currentUserObj);
            this._router.navigate([AppRoute.myProfileRoute]);
          }
        } else if (result.status === 0) {
          //this.apiResponseErrorMessage = result.message;
          this.fuseAlertService.show(result.message, result.status);
        } else {
          this.apiResponseErrorMessage = result.message;
        }
      });
    };
  }

  /**
   * On click of cancel button
   */
  onCancel(): void {
    this._router.navigate([AppRoute.myProfileRoute]);
  }

  /**
   * On chnage event of tab
   * @param event
   */
  onTabChange(event) {
    this.selectedIndex = event.index;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get user of company
   */
  getUser() {
    this._myProfileService.getUser().subscribe(res => {
      if (res.status === 1) {
        this.fuseAlertService.show(res.message, res.status);
        this.bindFormData(res.data);
      } else {
        this.fuseAlertService.show(res.message, res.status);
        
        this._router.navigate([AppRoute.dashboard]);
      }
    });
  }

  onChangeCountry(event) {
    if (event === null) {
      this.selectedCountryDropdown.value = 0;
      this.editProfileForm.controls.country.setValue(null);

    } else {
      this.selectedCountryDropdown = Object.assign({}, event);
      this.editProfileForm.controls.country.setValue(event.text);
    }
  }

  onChangeState(event) {
    if (event === null) {
      this.editProfileForm.controls.state.setValue(null);
    } else {
      this.editProfileForm.controls.state.setValue(event.text);
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Bind edit profile form 
   * @param model=Data to bind
   */
  bindFormData(model: any) {
    this.spinner.hide();
    this.myProfile = new MyProfile();
    this.myProfile.email = model.email;
    this.myProfile.firstName = model.firstName;
    this.myProfile.lastName = model.lastName;
    this.myProfile.extPhoneNumber = model.extPhoneNumber;
    this.myProfile.phoneNumber = model.phoneNumber;
    this.myProfile.profileImagePath = model.profileImagePath;

    this.editProfileForm.controls.firstName.setValue(model.firstName);
    this.editProfileForm.controls.lastName.setValue(model.lastName);
    this.editProfileForm.controls.extPhoneNumber.setValue(model.extPhoneNumber);
    this.editProfileForm.controls.phoneNumber.setValue(model.phoneNumber);

    if (model.editProfileAddressModel !== null) {
      let addressModel = new AddressModel();
      addressModel.city = model.editProfileAddressModel.city;
      addressModel.state = model.editProfileAddressModel.state;
      addressModel.street = model.editProfileAddressModel.street;
      addressModel.zipCode = model.editProfileAddressModel.zipCode;
      addressModel.country = model.editProfileAddressModel.country;

      this.myProfile.myProfileAddressModel = addressModel;

      this.editProfileForm.controls.city.setValue(model.editProfileAddressModel.city);
      this.editProfileForm.controls.state.setValue(model.editProfileAddressModel.state);
      this.editProfileForm.controls.country.setValue(model.editProfileAddressModel.country);
      this.editProfileForm.controls.street.setValue(model.editProfileAddressModel.street);
      this.editProfileForm.controls.zipCode.setValue(model.editProfileAddressModel.zipCode);

      this.selectedCountryName = model.editProfileAddressModel.country;
      this.selectedStateName = model.editProfileAddressModel.state;
    }
  }

  /**
   * Initialise change password form
   */
  setChangePasswordForm() {

    this.frmChangePassword = this._formBuilder.group({
      currentPassword: ["", Validators.required],
      newPassword: ["", [Validators.required, ValidationService.passwordValidator]],
      confirmPassword: ["", [Validators.required, confirmPasswordValidator]],
    });

    // Update the validity of the 'passwordConfirm' field
    // when the 'password' field changes
    this.frmChangePassword.get("newPassword").valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.frmChangePassword.get("confirmPassword").updateValueAndValidity();
      });

  }

  /**
   * Reset Change password form
   */
  resetChangePasswordForm() {
    this.frmChangePassword.reset();
    this.frmChangePassword.controls.currentPassword.setErrors(null);
    this.frmChangePassword.controls.newPassword.setErrors(null);
    this.frmChangePassword.controls.confirmPassword.setErrors(null);
  }

  /**
   * Initialise change and recover security code form
   */
  setOrChangeCompanyCodeForm() {

    this.frmSetOrChangeCompanyCode = this._formBuilder.group({
      currentCode: ['', [Validators.required, ValidationService.noWhiteSpace, ValidationService.onlyNumberValidator, Validators.pattern("^[0-9]*$"), Validators.maxLength(4)]],
      newCode: ['', [Validators.required, ValidationService.noWhiteSpace, ValidationService.onlyNumberValidator, Validators.pattern("^[0-9]*$"), Validators.maxLength(4)]],
      confirmCode: ['', [Validators.required, confirmCodeValidator, ValidationService.noWhiteSpace, ValidationService.onlyNumberValidator, Validators.pattern("^[0-9]*$"), Validators.maxLength(4)]]
    });

    // Update the validity of the 'passwordConfirm' field
    // when the 'password' field changes
    this.frmSetOrChangeCompanyCode.get("newCode").valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.frmSetOrChangeCompanyCode.get("confirmCode").updateValueAndValidity();
      });

    this.recoverSecurityCode(this.isSetCompanyCode);
  }

  get currentCodeControl() {
    return this.frmSetOrChangeCompanyCode.get('currentCode');
  }

  recoverSecurityCode(isRecoverCodeFlag: boolean) {
    this.isSetCompanyCode = isRecoverCodeFlag;
    if (!this.isSetCompanyCode) {
      //this.frmSetOrChangeCompanyCode.controls["currentCode"].disable()
      this.companyCodeLabel.CurrentCode = "Set Code";
      this.companyCodeLabel.NewCode = "New Company Code";
      this.companyCodeLabel.ConfirmCode = "Confirm Company Code";
    } else {
      //this.frmSetOrChangeCompanyCode.controls["currentCode"].enable();
      this.companyCodeLabel.CurrentCode = "Current Code";
      this.companyCodeLabel.NewCode = "New Company Code";
      this.companyCodeLabel.ConfirmCode = "Confirm Company Code";
    }
  }

  onSubmitSetOrChangeCompanyCode() {
    this.apiResponseErrorMessageChangeSecurityCode = null;
    var model = {
      CurrentCode: this.isSetCompanyCode ? this.frmSetOrChangeCompanyCode.controls.currentCode.value : "0000",
      NewCode: this.frmSetOrChangeCompanyCode.controls.newCode.value,
      ConfirmCode: this.frmSetOrChangeCompanyCode.controls.confirmCode.value,
      IsRecoverCode: !this.isSetCompanyCode,
      Email: this.email
    }
    if (this.frmSetOrChangeCompanyCode.dirty && this.frmSetOrChangeCompanyCode.valid) {
      this.spinner.show();
      this.authenticationService.doRecoverSecurityCode(model).subscribe(res => {
        this.spinner.hide();
        if (res.status == 1) {
          this.fuseAlertService.show(res.message, res.status);
          
          if (!this.isSetCompanyCode) {
            this.isSetCompanyCode = true;
            this.currentUser.isSecurityCodeSet = this.isSetCompanyCode;
            this.tabTitleLable = this.isSetCompanyCode ? "Change Company Code" : "Set Company Code";
            this.appConfig.setCurrentUser(this.currentUser);
          }
          this.recoverSecurityCode(this.isSetCompanyCode);
          this.resetCompanyCodeForm();
        }else if(res.status == 2){
          this.fuseAlertService.show(res.message, res.status);
        }else if(res.status == 0){
          this.fuseAlertService.show(res.message, res.status);
        }
         else {
          this.apiResponseErrorMessageChangeSecurityCode = res.message;
        }
      });
    };
  }

  resetCompanyCodeForm() {
    this.frmSetOrChangeCompanyCode.reset();
    this.frmSetOrChangeCompanyCode.controls.currentCode.setErrors(null);
    this.frmSetOrChangeCompanyCode.controls.newCode.setErrors(null);
    this.frmSetOrChangeCompanyCode.controls.confirmCode.setErrors(null);
    this.isSubmitChangePasswordBtnDisabled = true;
  }
  /**
   * Open Model window for cropping image and up
   */
  openModelPopUpCropImage() {
    this.dialogRef = this.matDialog.open(CropImageComponent, {
      panelClass: 'cropimage-section'
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {

        if (!response) {
          return;
        }

        const actionType: string = response[0];

        switch (actionType) {
          case 'submit':
            const selectedFile = response[1];
            this.updateProfilePicture(selectedFile);
            break;
          default:
            break;
        }
      });
  }

  /**
   * 
   * @param selectedFile
   */
  updateProfilePicture(selectedFile) {
    if (!selectedFile) {
      this.apiResponseErrorMessage = "Please select image";
      return;
    }
    var index = selectedFile.image.indexOf(","); // Get index of ',' to find the base 64 from image source,
    let model = {
      email: this.myProfile.email,
      base64Image: selectedFile.image.substring(index + 1), // Extract only base 64 from the image source
      userId : ''
    }
    this.spinner.show();
    this._myProfileService.updateProfilePicture(model).subscribe(res => {
      this.spinner.hide();
      if (res.status === 1) {
        this.myProfile.profileImagePath = res.data;
        var currentUserObj = this.appConfig.getCurrentUser();
        if (currentUserObj !== null && currentUserObj !== undefined) {
          currentUserObj.profilePic = res.data;
          this.appConfig.setCurrentUserAfterProfileUpdate(currentUserObj);
          this._myProfileService.changeMessage("Profile picture updated");
        }
        this.fuseAlertService.show(res.message, res.status);
      } else {
        this.apiResponseErrorMessage = res.message;
      }
    });
  }

}
export class CompanyCodeLabelModel {
  CurrentCode: string;
  NewCode: string;
  ConfirmCode: string;
}